import { render, staticRenderFns } from "./DamPredictionTable.vue?vue&type=template&id=56d61598&scoped=true"
import script from "./DamPredictionTable.vue?vue&type=script&lang=ts"
export * from "./DamPredictionTable.vue?vue&type=script&lang=ts"
import style0 from "./DamPredictionTable.vue?vue&type=style&index=0&id=56d61598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d61598",
  null
  
)

export default component.exports